var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53559 11.231V11.231C8.55763 10.2563 8.55495 8.67343 9.52961 7.69547L11.6473 5.57056C12.622 4.5926 14.2049 4.58992 15.1829 5.56458V5.56458C16.1608 6.53924 16.1635 8.12215 15.1888 9.10011L14.13 10.1626",
    stroke: "#262758"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3665 8.78626V8.78626C12.3444 9.76092 12.3471 11.3438 11.3724 12.3218L9.25471 14.4467C8.28005 15.4247 6.69714 15.4273 5.71918 14.4527V14.4527C4.74122 13.478 4.73854 11.8951 5.7132 10.9171L6.77207 9.85469",
    stroke: "#262758"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.2d86b076402c3200c9727a0780bc40f2.svg";
export { ForwardRef as ReactComponent };